enum FarmerOrderSkuRoutes {
  List = '/farmer-orders-sku',
  Edit = '/farmer-orders-sku/edit/:id',
  Add = '/farmer-orders-sku/add',
}

export default FarmerOrderSkuRoutes
